module.exports = __webpack_public_path__ + "media/images/icons/twotone/right-square-127c1dcae99ebfe29ee7e7232b2c901e.svg";